import { MatTableDataSource } from '@angular/material/table';
import { AfterViewInit, Component, DestroyRef, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ServicesService } from 'src/services/services.service';
import { MatSort } from '@angular/material/sort';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { elements } from 'chart.js';


export interface EventElement {
  event_id: string;
  event_name: string;
  event_type: string;
  created_by: string;
  created_date: string;
  description: string;
  pass_count: any;
  address: string;
  user_mobile: string;
  // user_pwd: string;
  user_name: string;
  total_reg: any;
  registered_count: any;
  from_date: string;
  to_date: string;
  event_logo: string;
  event_image: string;
  from_time: string;
  to_time: string;
  is_active: any;
  action: any;
}

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
  standalone: false
})
export class EventsComponent {
  displayedColumns: string[] = [
    'event_id',
    'is_active',
    'event_image',
    'event_logo',
    'event_name',
    'event_type',
    'total_reg',
    'address',
    'from_date',
    'to_date',
    'from_time',
    'to_time',
    'mobile',
    // 'password',
    'created_by',
    'created_date',
    'description',
    'pass_count',
    'action',
  ];

  ELEMENT_DATA: EventElement[] = [];
  event_result: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<EventElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngAfterViewInit() {
    this.Get_Event();
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Event() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_event().pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.event_result = data.data
        for (const item of this.event_result) {
          this.ELEMENT_DATA.push({
            event_id: item.event_id,
            event_name: item.event_name,
            event_type: item.event_type,
            created_by: item.created_by,
            created_date: item.created_date,
            description: item.description,
            pass_count: item.pass_count,
            address: item.address,
            user_mobile: item.user_mobile,
            // user_pwd: item.user_pwd,
            user_name: item.user_name,
            total_reg: item.total_reg,
            registered_count: item.registered_count,
            from_date: item.from_date,
            to_date: item.to_date,
            event_logo: `https://aieventzo.com/upload/event_logo/` + item.event_logo,
            event_image: `https://aieventzo.com/upload/event_image/` + item.event_image,
            from_time: item.from_time,
            to_time: item.to_time,
            is_active: item.is_active == 1 ? true : false,
            action: item.event_id
          });
          this.spinner.hide();
        }
        this.dataSource = new MatTableDataSource<EventElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  onCheckboxChange(user_id: any, element: any) {
    const isActiveValue = element.is_active ? 1 : 0;
    this.active_event(element.event_id, isActiveValue);
  }

  active_event(event_id: any, isActiveValue: any) {
    this.service.active_event(event_id, isActiveValue).subscribe();
  }

  Add_Event() {
    const user_id = sessionStorage.getItem("User_ID")
    this.router.navigate(['/admin/Events/AddEvent', { 'user_id': user_id }]);
  }

  Edit_Event(event_id: any) {
    this.router.navigate(['/admin/Events/EditEvent', { 'event_id': event_id }]);
  }

  Go(event_id: any) {
    // Save the event_id to local storage
    sessionStorage.setItem('Event_ID', event_id);

    // Navigate to the '/Registered Users' route
    this.router.navigate(['/admin/Registered Users']).then(() => {
      // Reload the page after navigation completes
      setTimeout(() => {
        window.location.reload();
      }, 100); // Adjust the delay if necessary
    });
  }



  DeleteEvent(event_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Event?');
    if (buttonClicked === true) {
      this.service.delete_event(event_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.event_id !== event_id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Event Deleted Succesfully");
        });
    }
  }

  deletePass(element: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete all Passed of ' + element.event_name + '(' + element.event_id + ') ?');

    if (buttonClicked === true) {
      this.service.delete_all_pass(element.event_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.dataSource.data = this.ELEMENT_DATA;
          alert("All passes deleted successfully");
          window.location.reload();
        });
    }
    
  }
}
